module.exports = __webpack_public_path__ + "img/comment_1_1.bb8f4753.jpg";